<template>
  <router-view />
</template>

<script>
export default {
  name: 'CollegeDetail',
};
</script>
